export default function formatTimestampToMonthAndYear(timestamp) {
  if (!timestamp) return 'Present';

  // Handle Firestore timestamp
  const milliseconds = timestamp.seconds ? timestamp.seconds * 1000 : timestamp;
  const date = new Date(milliseconds);

  return date.toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
  });
}
